import React from 'react';
import EcocashLogo from '../../../../assets/images/payment-methods/ecocash.svg';
import VisaLogo from '../../../../assets/images/payment-methods/visa.svg';
import PaynowLogo from '../../../../assets/images/paynow/button_make-payment_large.svg';
import AppFormInput from '../../../../components/ui/AppFormInput';

const PAYMENT_METHODS = [
  { value: 'Ecocash', label: 'Ecocash', logo: EcocashLogo },
  { value: 'Pay with Card', label: 'Visa Card', logo: VisaLogo },
  { value: 'Pay using Paynow', label: 'Paynow', logo: PaynowLogo },
];

function GuestPaymentForm({
  paymentMethod,
  policyNumber,
  payerName,
  emailAddress,
  phoneNumber,
  amount,
  cardNumber,
  expiryMonth,
  expiryYear,
  cvv,
  cardHolderName,
  handlePaymentMethodChange,
  handlePolicyNumberChange,
  handlePayerNameChange,
  handleEmailAddressChange,
  handlePhoneNumberChange,
  handleAmountChange,
  handleCardNumberChange,
  handleExpiryMonthChange,
  handleExpiryYearChange,
  handleCvvChange,
  handleCardHolderNameChange,
  submitPaymentRequest,
  isSubmitting,
}) {
  const showFields = paymentMethod === 'Ecocash' || paymentMethod === 'Pay with Card';

  return (
    <form name="guestPaymentForm" onSubmit={submitPaymentRequest} className="flex flex-col gap-6">
      <div>
        <h3 className="text-sm font-bold text-slate-700 mb-3 uppercase tracking-wider">Payment Method</h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {PAYMENT_METHODS.map((method) => (
            <button type="button" aria-pressed={paymentMethod === method.value}
              key={method.value}
              className={`cursor-pointer border-2 rounded-xl p-4 flex items-center justify-center transition-all bg-white ${
                paymentMethod === method.value
                  ? 'border-[#135A9C] ring-2 ring-[#135A9C]/20 shadow-md'
                  : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'
              }`}
              onClick={() => handlePaymentMethodChange(method.value)}



            >
              <img className="h-8 max-w-full object-contain" src={method.logo} alt={method.label} />
            </button>
          ))}
        </div>
      </div>

      {paymentMethod === 'Ecocash' && (
        <div>
          <h3 className="text-sm font-bold text-slate-700 mb-3 uppercase tracking-wider">Policy Details</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <AppFormInput
              label="Policy Number"
              type="text"
              placeholder="e.g. FP12345678"
              name="policyNumber"
              required
              value={policyNumber}
              onChange={handlePolicyNumberChange}
              containerClassName="form-control w-full"
            />

            <AppFormInput
              label="Amount (USD)"
              type="number"
              min="0.01"
              step="0.01"
              placeholder="0.00"
              name="amount"
              required
              value={amount}
              onChange={handleAmountChange}
              containerClassName="form-control w-full"
            />
          </div>
        </div>
      )}

      {paymentMethod === 'Pay with Card' && (
        <div>
          <h3 className="text-sm font-bold text-slate-700 mb-3 uppercase tracking-wider">Policy Search</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <AppFormInput
              label="Policy Number"
              type="text"
              placeholder="e.g. FP12345678"
              name="policyNumber"
              required
              value={policyNumber}
              onChange={handlePolicyNumberChange}
              containerClassName="form-control w-full"
            />
          </div>
        </div>
      )}

      {paymentMethod === 'Ecocash' && (
        <div>
          <h3 className="text-sm font-bold text-slate-700 mb-3 uppercase tracking-wider">Your Details</h3>
          <div className="grid grid-cols-1 gap-4">
            <AppFormInput
              label="Full Name"
              type="text"
              placeholder="John Doe"
              name="payerName"
              required
              value={payerName}
              onChange={handlePayerNameChange}
              containerClassName="form-control w-full"
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <AppFormInput
                label="Email Address"
                type="email"
                placeholder="john@example.com"
                name="emailAddress"
                required
                value={emailAddress}
                onChange={handleEmailAddressChange}
                containerClassName="form-control w-full"
              />
              <AppFormInput
                label="Ecocash Phone Number"
                type="text"
                placeholder="077..."
                name="phoneNumber"
                required
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                containerClassName="form-control w-full"
              />
            </div>
          </div>
        </div>
      )}

      {showFields && (
        <button
          type="submit"
          disabled={isSubmitting}
          className={`btn w-full py-4 text-lg font-bold shadow-lg shadow-slate-200 border-none text-white transition-transform active:scale-[0.98] ${
            'bg-[#135A9C] hover:bg-[#0f4a82]'
          }`}
        >
          {isSubmitting && (
            <span className="flex items-center justify-center gap-2">
              <span className="loading loading-spinner loading-sm"></span> Processing...
            </span>
          )}
          {!isSubmitting && (paymentMethod === 'Pay with Card' ? 'Verify Policy & Continue' : `Pay with ${paymentMethod}`)}
        </button>
      )}

      {paymentMethod === 'Pay using Paynow' && (
        <iframe
          src="https://www.topup.co.zw/billpay/widget/doves-funeral-services?iframe=true"
          title="Doves Paynow Payment"
          className="w-full h-[70vh] border border-slate-200 rounded-2xl shadow-sm"
        ></iframe>
      )}

      {!paymentMethod && (
        <div className="alert alert-info bg-blue-50 text-blue-800 border-none rounded-xl mt-4">
          <i className="pi pi-info-circle text-xl"></i>
          <span>Choose a payment method above to continue.</span>
        </div>
      )}
    </form>
  );
}

export default GuestPaymentForm;
